import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { Icon } from "@/ds";

import { useGanttContext } from "../gantt.context";
import styles from "../gantt.module.scss";
import type { GanttGroupRowViewProps } from "../types-gantt";

/** Cabeçalho de grupo: uma célula de largura toda com o chevron e o rótulo; a linha do Hoje atravessa a faixa para não quebrar entre as linhas. */
export function GanttGroupRowView({ group }: GanttGroupRowViewProps) {
  const {
    columnCount,
    groupToggleTestId,
    todayStyle,
    todayGroupTestId,
    withActions,
    classNames: partClassNames,
  } = useGanttContext();

  return (
    <div
      className={classNames(styles.row, styles.groupRow, partClassNames.group)}
      data-testid={group.testId}
      role="row"
    >
      <div className={styles.groupCell} role="cell" aria-colspan={columnCount}>
        <Button
          type="button"
          text
          icon={<Icon name={group.toggleIcon} size={14} />}
          className={styles.groupToggle}
          aria-expanded={group.expanded}
          aria-label={group.toggleLabel}
          onClick={group.onToggle}
          data-testid={groupToggleTestId}
        >
          {group.label}
        </Button>
      </div>
      {todayStyle ? (
        <div className={styles.groupTrack} data-with-actions={withActions || undefined} aria-hidden>
          <span className={styles.today} style={todayStyle} data-testid={todayGroupTestId} />
        </div>
      ) : null}
    </div>
  );
}
GanttGroupRowView.displayName = "Gantt.GroupRow";
